import { Injectable } from '@angular/core';
import { Api } from '../providers';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient } from '@angular/common/http';
import { MyEventsProvider } from '../my-events/my-events';
import { Subject } from 'rxjs';

/*
  Generated class for the CurrentEventProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CurrentEventProvider {
    private event = new BehaviorSubject<any>({});
    currentEvent = this.event.asObservable();

    private firstShow = new BehaviorSubject<boolean>(false);
    showWelcome = this.firstShow.asObservable();

    private matchmakingWizard = new BehaviorSubject<boolean>(false);
    showMatchWiz = this.matchmakingWizard.asObservable();

    private segment = new BehaviorSubject<any>(null);
    currentSegment = this.segment.asObservable();

    public selectedEvent: any;

    activeEvents: any;

    commentAdded = false;

    navigationTabClicked$ = new Subject();

    constructor(private api: Api,
        private myEventsProvider: MyEventsProvider) { }

    clickTab(navData: any) {
        this.navigationTabClicked$.next(navData);
    }

    subscribeToTabClick(callback: any) {
        return this.navigationTabClicked$.subscribe(data => {
            callback(data);
        })
    }

    setCurrentEvent(event: any) {
        this.selectedEvent = event;
        this.event.next(event);
        this.loadHeaderEvents();
    }

    setCurrentSegment(segment: string) {
        this.segment.next(segment);
    }

    getEvent(pin: string): Observable<any> {
        return this.api.get('events/loadByPid', { eventPin: pin });
    }

    getCurrentEvent() {
        return this.event.getValue();
    }

    getCurrentSegment() {
        return this.segment.getValue();
    }

    getCurrentEventUuid() {
        const event = this.event.getValue();
        return event.uuid;
    }

    setFirstShow(isVisible) {
        this.firstShow.next(isVisible);
    }
    setMatchmakingWizardShow(isVisible) {
        this.matchmakingWizard.next(isVisible);
    }

    setFalseShow() {
        this.firstShow.next(false);
    }

    loadHeaderEvents() {
        this.myEventsProvider.getMyEvents('CURRENT').subscribe(events => {
            this.activeEvents = events;
            this.myEventsProvider.getMyEvents('UPCOMING').subscribe(events => {
                this.activeEvents = [...this.activeEvents, ...events];
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/current-event/current-event.ts